





















































































































import { DocumentReviewState } from "@/enums";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import storeHelper from "@/store/store-helper";
import { DocumentReviewer, DocumentReviewRound, ReviewRoundType } from "@/types/document/documentReviewer";
import { getDocumentReviewersAsync } from "@/documents";
import i18n from "@/plugins/i18n";
import _ from "lodash";
import Utils from "@/utils";
import { TranslateResult } from "vue-i18n/types";
type PropsReviewHistory = {
    documentId: string;
    documentVersionNumber: number;
};
export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    props: {
        documentId: String,
        documentVersionNumber: Number,
        revision: Number
    },
    data: function () {
        return {
            reviewers: null as DocumentReviewer[],
            reviewRounds: null as DocumentReviewRound[],
            reviewRound: "test",

            reviewRoundType: { ...ReviewRoundType },
            currentReviewRoundName: ""
        };
    },
    computed: {
        changedProps(): PropsReviewHistory {
            return {
                documentId: this.documentId,
                documentVersionNumber: this.documentVersionNumber
            };
        },
        currentReviewRound(): DocumentReviewRound {
            if (this.reviewRounds) {
                return this.reviewRounds.find(r => r.active);
            }
        },
        currentDateFormat(): string {
            return storeHelper.userStore.loggedOnUser.date_format;
        },
        xs(): boolean {
            return this.$vuetify.breakpoint.xs;
        },
        smAndUp(): boolean {
            return this.$vuetify.breakpoint.smAndUp;
        },
        isInternetExplorer(): boolean {
            return Utils.isIE11;
        }
    },
    methods: {
        toCalendar(itemDate: string): string {
            if (itemDate) {
                return Utils.formatDate(itemDate.toDate(), this.currentDateFormat);
            } else {
                return "";
            }
        },

        isArrowVisible(index: number, countReviewers: number, roundType: ReviewRoundType) {
            return roundType === ReviewRoundType.serial_reviewers && index < countReviewers - 1;
        },
        getUserinitials(userName: string) {
            let initials = "";

            if (!userName) return "";

            userName.split(" ").forEach(x => {
                if (x != "") initials += x.charAt(0);
            });
            return initials.substring(0, 2).toUpperCase();
        },
        getReviewStateText(state: DocumentReviewState): TranslateResult {
            switch (state) {
                case DocumentReviewState.approved:
                    return i18n.t("document.review.history.approved");
                case DocumentReviewState.rejected:
                    return i18n.t("document.review.history.rejected");
                default:
                    return "";
            }
        },
        getAvatarColor: function (reviewer: DocumentReviewer) {
            switch (reviewer.state) {
                case DocumentReviewState.approved:
                    return "success";
                case DocumentReviewState.rejected:
                    return "error";
                default:
                    return "grey";
            }
        },
        getReviewerDeadline(reviewer: DocumentReviewer) {
            if (reviewer.deadline_date) {
                return this.toCalendar(reviewer.deadline_date);
            } else if (reviewer.deadline_days > 0) {
                return `+ ${i18n.tc(
                    reviewer.round.type == ReviewRoundType.serial_reviewers
                        ? "document.review.history.deadlineValueDaysSerial"
                        : "document.review.history.deadlineValueDays",
                    1,
                    {
                        numberOfDays: reviewer.deadline_days
                    }
                )}`;
            } else {
                return "-";
            }
        },
        getCurrentRoundDeadline(round: DocumentReviewRound): any {
            let reviewerOfCurrentRound = this.reviewers.filter(r => r.round.round_id === round.round_id);
            if (reviewerOfCurrentRound) {
                let reviewerForDeadline;
                if (round.type === ReviewRoundType.serial_reviewers) {
                    reviewerForDeadline = this.reviewers.filter(r => r.round.round_id === round.round_id && r.active === true)[0];
                } else {
                    reviewerForDeadline = this.reviewers.filter(r => r.round.round_id === round.round_id)[0];
                }
                if (reviewerForDeadline) {
                    return this.getReviewerDeadline(reviewerForDeadline);
                }
                return "-";
            }
        },
        async init(): Promise<void> {
            this.reviewers = await getDocumentReviewersAsync(this.documentId, this.documentVersionNumber, null, null, true);
            const allReviewRounds = this.reviewers.map(r => r.round);
            this.reviewRounds = allReviewRounds
                .map(e => e["round_id"])
                .map((e, i, final) => final.indexOf(e) === i && i)
                .filter(obj => allReviewRounds[obj])
                .map(e => allReviewRounds[e]);
            this.currentReviewRoundName = this.currentReviewRound?.name;
        }
    },
    watch: {
        changedProps: {
            async handler(newValue: PropsReviewHistory, oldValue: PropsReviewHistory) {
                this.init();
            },
            immediate: true
        }
    }
});
